import { useChangeCache } from "@/hooks/use-change-cache";
import { Features } from "@/store/features/features";
import { selectHasFeature } from "@/store/features/features-slice";
import { useAppSelector } from "@/store/store-hooks";
import type { RegistrationRevision } from "@faro-lotv/service-wires";
import { isEqual } from "es-toolkit";
import { useEffect } from "react";

/**
 * @param revision The revision to log changes of. Requires `RegistrationDev` feature to be enabled.
 */
export function useLogRevisionChangesOnDev(
  revision: RegistrationRevision | undefined,
): void {
  const hasChanged = useChangeCache();
  const hasRegistrationDevFeature = useAppSelector(
    selectHasFeature(Features.RegistrationDev),
  );

  useEffect(() => {
    if (
      hasChanged("hasRegistrationDevFeature", hasRegistrationDevFeature) ||
      hasChanged("revision", revision, isEqual)
    ) {
      if (hasRegistrationDevFeature) {
        console.debug("revision changed", revision);
      }
    }
  }, [revision, hasChanged, hasRegistrationDevFeature]);
}
